<h4 class="sidebar-title">{{ 'COMMON.USER.ROLES' | translate }}</h4>
<ul class="item-list">
  <li 
    *ngFor="let item of sidebarItems; let i = index"
    [class.active]="item.id === selectedItem"
    (click)="selectItem(item.id)">
    {{ item.name| translate}}
  </li>
</ul>
